"use strict";

var applyCondition = require('./applyCondition');

function setShippingOptions(shipment, options) {
  if (!options.setShipStationShippingOptions) {
    throw new Error('ensure you have added setShipStationShippingOptions in ShineShipping settings');
  }

  if (!Array.isArray(options.setShipStationShippingOptions)) {
    throw new Error('setShipStationShippingOptions must be an array');
  }

  var opts = options.setShipStationShippingOptions;
  var matching_option = {}; // iterate over every item in setShipStationItems
  // to see which one matches all conditions.

  for (var i = 0; i < opts.length; i++) {
    var _opts$i = opts[i],
        carrierCode = _opts$i.carrierCode,
        serviceCode = _opts$i.serviceCode,
        packageCode = _opts$i.packageCode,
        confirmation = _opts$i.confirmation,
        conditions = _opts$i.conditions;
    var passing = conditions.map(function (condition) {
      return applyCondition(shipment, condition);
    }); // array of booleans

    if (passing.every(function (a) {
      return a;
    })) {
      matching_option = {
        carrierCode: carrierCode,
        serviceCode: serviceCode,
        packageCode: packageCode,
        confirmation: confirmation
      };
      break;
    }
  }

  return matching_option;
}

module.exports = setShippingOptions;